/* Birdline four-state search. Data comes from Shopify predictive search. */
(function () {
  var form = document.querySelector('[data-bl-search]');
  if (!form || form.dataset.blSearchReady === 'true') return;
  form.dataset.blSearchReady = 'true';

  var dialog = form.closest('dialog');
  var input = form.querySelector('[data-bl-search-input]');
  var title = form.querySelector('[data-bl-title]');
  var clearButton = form.querySelector('[data-bl-search-clear]');
  var browse = form.querySelector('[data-bl-search-browse]');
  var predictive = form.querySelector('[data-bl-search-predictive]');
  var results = form.querySelector('[data-bl-search-results]');
  var loading = form.querySelector('[data-bl-search-loading]');
  var empty = form.querySelector('[data-bl-search-empty]');
  var error = form.querySelector('[data-bl-search-error]');
  var live = form.querySelector('[data-bl-search-live]');
  var viewAll = form.querySelector('[data-bl-search-view-all]');
  var viewAllLabel = form.querySelector('[data-bl-search-view-all-label]');
  var closeButton = form.querySelector('[data-bl-search-close]');
  if (!dialog || !input) return;

  var debounceTimer = null;
  var abortController = null;
  var lastTrigger = null;
  var lastQuery = '';
  var originalHtmlOverflow = '';
  var originalHtmlPaddingRight = '';
  var pageLocked = false;

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function safeUrl(url) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin ? parsed.pathname + parsed.search : '';
    } catch (e) {
      return '';
    }
  }

  function formatMoney(value) {
    if (value == null || value === '') return '';
    if (typeof value === 'number') return '$' + (value / 100).toFixed(2);
    var number = Number(String(value).replace(/[^0-9.-]/g, ''));
    return Number.isFinite(number) ? '$' + number.toFixed(2) : '';
  }

  function setInitialState() {
    lastQuery = '';
    title.textContent = 'What are you looking for?';
    browse.hidden = false;
    predictive.hidden = true;
    loading.hidden = true;
    empty.hidden = true;
    error.hidden = true;
    results.innerHTML = '';
    live.textContent = '';
  }

  function setPredictiveState(query) {
    title.textContent = 'Search Birdline';
    browse.hidden = true;
    predictive.hidden = false;
    loading.hidden = false;
    empty.hidden = true;
    error.hidden = true;
    results.innerHTML = '';
    viewAll.href = '/search?q=' + encodeURIComponent(query) + '&type=product&options%5Bprefix%5D=last';
    viewAllLabel.textContent = 'View all results for “' + query + '”';
  }

  function productHandle(product) {
    var path = safeUrl(product.url || '');
    var match = path.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  var productCache = {};
  function hydrateProducts(products) {
    return Promise.all(products.slice(0, 4).map(function (product) {
      var handle = productHandle(product);
      if (!handle) return product;
      if (productCache[handle]) return Object.assign(product, productCache[handle]);
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Product request failed'); return response.json(); })
        .then(function (full) {
          var firstAvailable = (full.variants || []).find(function (variant) { return variant.available; }) || (full.variants || [])[0] || {};
          var patch = {
            __image: firstAvailable.featured_image && firstAvailable.featured_image.src ? firstAvailable.featured_image.src : full.featured_image,
            __price: full.price,
            __priceVaries: full.price_min !== full.price_max,
            __priceMin: full.price_min,
            __variantId: firstAvailable.id,
            __available: full.available
          };
          productCache[handle] = patch;
          return Object.assign(product, patch);
        })
        .catch(function () { return product; });
    }));
  }

  function productCard(product) {
    var url = safeUrl(product.url || '');
    if (!url) return '';
    if (product.__variantId) url += (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + encodeURIComponent(product.__variantId);
    var image = product.__image || (product.featured_image && (product.featured_image.url || product.featured_image)) || product.image || '';
    var price = product.__priceVaries ? 'From ' + formatMoney(product.__priceMin) : formatMoney(product.__price != null ? product.__price : product.price);
    return '<li><a class="bl-search__product" href="' + escapeHtml(url) + '">' +
      '<span class="bl-search__product-media">' + (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" width="320" height="400" loading="lazy">' : '') + '</span>' +
      '<strong>' + escapeHtml(product.title) + '</strong>' +
      '<span class="bl-search__product-price">' + escapeHtml(price) + '</span>' +
      (product.__available === false ? '<span class="bl-search__sold-out">Sold out</span>' : '') +
      '</a></li>';
  }

  function suggestionItem(item, label) {
    var url = safeUrl(item.url || '');
    if (!url) return '';
    return '<li><a href="' + escapeHtml(url) + '"><span>' + escapeHtml(item.title || item.text || item.styled_text || '') + '</span><em>' + escapeHtml(label) + '</em></a></li>';
  }

  function renderPredictive(data, query) {
    var resourceResults = data && data.resources && data.resources.results ? data.resources.results : {};
    var products = (resourceResults.products || []).slice(0, 4);
    var collections = (resourceResults.collections || []).slice(0, 5);
    var queries = (resourceResults.queries || []).slice(0, 5);
    var suggestionHtml = queries.map(function (item) { return suggestionItem(item, 'Suggested search'); }).join('') +
      collections.map(function (item) { return suggestionItem(item, 'Collection'); }).join('');
    var productHtml = products.map(productCard).join('');
    var total = products.length + collections.length + queries.length;

    loading.hidden = true;
    error.hidden = true;
    empty.hidden = total !== 0;
    if (!total) {
      results.innerHTML = '';
      live.textContent = 'No predictive results for ' + query + '.';
      return;
    }

    var html = '<div class="bl-search__predictive-grid">';
    if (suggestionHtml) {
      html += '<section class="bl-search__suggestions" aria-labelledby="BlSearchSuggestionsHeading"><p id="BlSearchSuggestionsHeading" class="bl-search__section-title">Suggested searches</p><ul role="list">' + suggestionHtml + '</ul></section>';
    }
    if (productHtml) {
      html += '<section class="bl-search__products" aria-labelledby="BlSearchProductsHeading"><p id="BlSearchProductsHeading" class="bl-search__section-title">Products</p><ul class="bl-search__trending-grid" role="list">' + productHtml + '</ul></section>';
    }
    html += '</div>';
    results.innerHTML = html;
    live.textContent = total + (total === 1 ? ' predictive result' : ' predictive results') + ' available for ' + query + '.';
  }

  function requestPredictive(query) {
    if (abortController) abortController.abort();
    abortController = new AbortController();
    var requestUrl = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(requestUrl, { signal: abortController.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Predictive search request failed'); return response.json(); })
      .then(function (data) {
        if (query !== lastQuery) return;
        var products = data && data.resources && data.resources.results ? data.resources.results.products || [] : [];
        return hydrateProducts(products).then(function () { if (query === lastQuery) renderPredictive(data, query); });
      })
      .catch(function (requestError) {
        if (requestError.name === 'AbortError' || query !== lastQuery) return;
        loading.hidden = true;
        empty.hidden = true;
        error.hidden = false;
        results.innerHTML = '';
        live.textContent = 'Predictive search is unavailable. Press Enter for full results.';
      });
  }

  function onInput() {
    var query = input.value.trim();
    clearButton.hidden = query.length === 0;
    window.clearTimeout(debounceTimer);
    if (abortController) abortController.abort();
    if (!query) {
      setInitialState();
      return;
    }
    lastQuery = query;
    setPredictiveState(query);
    debounceTimer = window.setTimeout(function () { requestPredictive(query); }, 250);
  }

  function lockPage() {
    if (pageLocked) return;
    pageLocked = true;
    originalHtmlOverflow = document.documentElement.style.overflow;
    originalHtmlPaddingRight = document.documentElement.style.paddingRight;
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden';
    if (scrollbarWidth > 0) document.documentElement.style.paddingRight = scrollbarWidth + 'px';
  }

  function unlockPage() {
    if (!pageLocked) return;
    pageLocked = false;
    document.documentElement.style.overflow = originalHtmlOverflow;
    document.documentElement.style.paddingRight = originalHtmlPaddingRight;
  }

  function openSearch(trigger) {
    lastTrigger = trigger || document.activeElement;
    if (!dialog.open) {
      try { dialog.showModal(); } catch (e) { return; }
    }
    lockPage();
    window.requestAnimationFrame(function () { input.focus(); });
  }

  function closeSearch() {
    if (dialog.open) dialog.close();
  }

  function actionTrigger(element, action) {
    var current = element;
    while (current && current !== document) {
      if (current.getAttribute && current.getAttribute('on:click') === '#search-modal/' + action) return current;
      if (current.hasAttribute && current.hasAttribute('data-bl-search-' + (action === 'showDialog' ? 'open' : 'close'))) return current;
      current = current.parentElement;
    }
    return null;
  }

  input.addEventListener('input', onInput);
  clearButton.addEventListener('click', function () { input.value = ''; onInput(); input.focus(); });
  closeButton.addEventListener('click', closeSearch);

  document.addEventListener('click', function (event) {
    var trigger = actionTrigger(event.target, 'showDialog');
    if (trigger) { event.preventDefault(); openSearch(trigger); return; }
    if (actionTrigger(event.target, 'closeDialog')) { event.preventDefault(); closeSearch(); }
  });

  dialog.addEventListener('click', function (event) { if (event.target === dialog) closeSearch(); });
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); closeSearch(); });
  dialog.addEventListener('close', function () {
    unlockPage();
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  });

  dialog.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var focusable = Array.from(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  setInitialState();
})();
